import { Box, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

//import general components
import MobileHeader from "../../../common/mobile-header/mobile-header";

//import images and icons
import { ArrowForward } from "iconsax-react";

//import styles
import "./problem-type.scss";

function ProblemType({ requestList, handleClick }) {
    //genetal
    const { t } = useTranslation();

    return (
        <>
            <MobileHeader title={t("support")} justifyContent="center" handleClick={() => handleClick("isMain")} />
            <Grid className="problem-type" container item xs={12} md={7} xl={6} rowGap={3.5}>
                <Grid container item xs={12} alignItems="flex-start">
                    <Grid container item xs={12} sm={10} justifyContent={{ xs: "center", sm: "flex-start" }}>
                        <span className="problem-type__title">{t("problemTypeTitle")}</span>
                    </Grid>
                    <Grid
                        className="request-form__undo"
                        container
                        item
                        xs={2}
                        columnGap={1}
                        justifyContent="flex-end"
                        alignItems="center"
                        display={{ xs: "none", sm: "flex" }}
                        onClick={() => handleClick("isMain")}
                    >
                        {t("back")} <ArrowForward color="var(--primary-color)" />
                    </Grid>
                </Grid>

                <Grid container item xs={12} rowGap={3} justifyContent={{ sm: "space-between", md: "flex-start" }}>
                    {requestList.support_type &&
                        requestList.support_type.map(typeItem => {
                            return (
                                <Grid key={typeItem.id} container item xs={6} sm={1.9} md={3} justifyContent="center">
                                    <Box className="problem-type__category" onClick={() => handleClick("isSubType", typeItem.id)}>
                                        <span>{typeItem.name}</span>
                                    </Box>
                                </Grid>
                            );
                        })}
                </Grid>
            </Grid>
        </>
    );
}

export default ProblemType;
